// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1903":"864a7136","2140":"6b6d3646","6626":"6b6d3646","7691":"96f458d1","7996":"3c36898e"}[chunkId] + ".chunk.css";
};